export const DASHBOARD_NDR_COUNTER_CARDS_ACTION="DASHBOARD_NDR_COUNTER_CARDS_ACTION"
export const DASHBOARD_NDR_STATUS_ACTION="DASHBOARD_NDR_STATUS_ACTION"
export const DASHBOARD_NDR_SUCCESS_BY_COURIER_ACTION="DASHBOARD_NDR_SUCCESS_BY_COURIER_ACTION"
export const DASHBOARD_NDR_SUCCESS_BY_ZONE_ACTION="DASHBOARD_NDR_SUCCESS_BY_ZONE_ACTION"
export const DASHBOARD_NDR_DELIVERY_ATTEMPT_ACTION = "DASHBOARD_NDR_DELIVERY_ATTEMPT_ACTION"
export const DASHBOARD_NDR_FUNNEL_ACTION = "DASHBOARD_NDR_FUNNEL_ACTION"
export const DASHBOARD_NDR_RESPONSE_ACTION = "DASHBOARD_NDR_RESPONSE_ACTION"
export const DASHBOARD_NDR_REASON_SPLIT_ACTION = "DASHBOARD_NDR_REASON_SPLIT_ACTION"
export const DASHBOARD_NDR_BUYER_ACTION = "DASHBOARD_NDR_BUYER_ACTION"